import { createAction } from 'redux-actions';

export const saveProjectStatus = createAction('SAVE_PROJECT_STATUS');
export const receiveProjectStatuses = createAction('RECEIVE_PROJECT_STATUSES');
export const receiveProjectStatus = createAction('RECEIVE_PROJECT_STATUS');
export const displayProjectStatusError = createAction('DISPLAY_PROJECT_STATUS_ERROR');
export const fetchEngagementProjectStatuses = createAction('FETCH_ENGAGEMENT_PROJECT_STATUSES');
export const unloadProjectStatuses = createAction('UNLOAD_PROJECT_STATUSES');
